export default "__VITE_ASSET__o0mJ5XRD__"